import React, { useState, useEffect, useRef, Suspense, lazy } from 'react';

import NotificationButton from './NotificationButton';
// import NotificationContent from './NotificationContent';
const NotificationContent = lazy(() => import('./NotificationContent'));
import { useAuth } from '../../contexts/auth';

const NotificationsTray = () => {
  const { currentUser } = useAuth();
  const [isOpen, setIsOpen] = useState(false); // Tray open/close state
  const divRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (buttonRef.current && buttonRef.current.contains(event.target as Node)) {
      return;
    }
    if (
      divRef.current &&
      event.target instanceof Node && // Ensure event.target is a Node
      !divRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  const handleOpenTray = async () => {
    if (!currentUser) return;
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="notifications-tray">
      <div ref={buttonRef}>
        <NotificationButton handleOpenTray={handleOpenTray} />
      </div>

      {isOpen && currentUser && (
        <div ref={divRef} className="tray-content scroller pb-6">
          <Suspense fallback={<div className="text-sm p-4">Loading notifications...</div>}>
            <NotificationContent />
          </Suspense>
        </div>
      )}
    </div>
  );
};

export default NotificationsTray;
